<template>
    <div class="events-wrapper">
        <el-row class="event-actions">
            <el-col :span="1" class="icons">
                <el-upload
                    action=""
                    :auto-upload="false"
                    :on-change="handleChange"
                    :on-exceed="handleExceed"
                    :limit="10"
                    :file-list="uploadFileList"
                    :show-file-list="false"
                >
                    <div class="event-icon-attach-orange"></div>
                </el-upload>
            </el-col>
            <el-col :span="20" v-loading="commentSending">
                <el-input
                    type="textarea"
                    :autosize="{ minRows: 3, maxRows: 5}"
                    placeholder=""
                    v-model="commentText"
                    class="event-actions-comment"
                />
                <div class="event-comment-attachments">
                    <el-tag
                        v-for="file in uploadFileList"
                        :key="file.uid"
                        closable
                        :type="''"
                        @close="handleClose(file)"
                        size="mini"
                        :disable-transitions="true"
                        color="#FFF"
                    >
                        {{ file.name }}
                    </el-tag>
                </div>
            </el-col>
            <el-col :span="3" class="send-btn">
                <div :class="{ 'event-icon-arrow-orange': canAddComment, 'event-icon-arrow-gray': !canAddComment,}" @click="addComment"></div>
            </el-col>
        </el-row>
        <el-row>
            <el-col>
                <scrolly class="wrap-events-scroll">
                    <scrolly-viewport>
                        <div class="wrap-events" v-loading="loading">
                            <template v-for="(event) in eventsList">
                                <div
                                    :class="
                                        [
                                            'event-item',
                                            'card',
                                            {'is-email-event' : isEventEmail(event.event_type) },
                                            'grey3',
                                            'mb10',
                                            getEventWrapClass(event.event_type)
                                        ]"
                                    :key="event.id"
                                    v-if="eventIsset(event)"
                                >
                                    <el-row class="event-item-wrapper">
                                        <div class="event-icon-wrap">
                                            <div :class="['icon', getEventMainIconClass(event.event_type)]"></div>
                                        </div>
                                        <el-col :span="23" class="event-right-column">
                                            <el-row>
                                                <el-col :span="24" :class="['event-title', { 'without-mb': isEventCall(event.event_type) && !event.data.extraText }]">
                                                    <span v-if="initiatorIsset(event)">
                                                        {{ event.created_at }}
                                                        <template v-if="isEventCall(event.event_type)">
                                                            <template v-if="showEmployerLink(event)">
                                                                <span
                                                                    class="event-link pointer"
                                                                    v-if="messageIsset(event)"
                                                                    @click="goEmployer(event.data.employerLink.id)"
                                                                >
                                                                    {{ event.data.employerLink.title }}
                                                                </span>
                                                            </template>
                                                            {{ initiatorTitle(event) }}.
                                                            <span v-if="event.data.audioLink" class="event-link pointer" @click="showHideAudio(event)">
                                                                <template v-if="isShowAudio(event)">
                                                                    Скрыть
                                                                </template>
                                                                <template v-else>
                                                                    Прослушать
                                                                </template>
                                                            </span>
                                                        </template>
                                                        <template v-else-if="showInitiatorLink(event.data.initiator)">
                                                            <span class="event-link pointer" @click="goEmployer(event.data.initiator.info.id)">
                                                                {{ initiatorTitle(event) }}
                                                            </span>
                                                            <template v-if="isEventComment(event.event_type)">
                                                                <span class="static-text">добавил комментарий</span>
                                                            </template>
                                                        </template>
                                                        <template v-else>
                                                            {{ initiatorTitle(event) }}
                                                        </template>
                                                    </span>
                                                </el-col>
                                            </el-row>
                                            <el-row v-if="isEventCall(event.event_type)">
                                                <el-col :span="24">
                                                    <audio controls v-if="event.data.audioLink && isShowAudio(event)" :class="[{ 'mt10': !event.data.extraText }]">
                                                        <source :src="event.data.audioLink" type="audio/ogg; codecs=vorbis">
                                                        <source :src="event.data.audioLink" type="audio/mpeg">
                                                        Тег audio не поддерживается вашим браузером.
                                                    </audio>
                                                </el-col>
                                            </el-row>
                                            <el-row>
                                                <template v-if="isEventCall(event.event_type) && event.data.extraText ">
                                                    <el-col :span="24" class="content-default">
                                                        <span>
                                                            &nbsp;{{ event.data.extraText }}
                                                        </span>
                                                    </el-col>
                                                </template>
                                                <el-col :span="24">
                                                    <template v-if="isEventEmail(event.event_type)">
                                                        <div
                                                            v-if="messageIsset(event)"
                                                            class="event-item-email"
                                                        >
                                                            <el-collapse accordion>
                                                                <el-collapse-item>
                                                                    <template
                                                                        slot="title"
                                                                    >
                                                                        <div
                                                                            class="email-event-title"
                                                                            @click="showEventLetter(event)"
                                                                        >
                                                                            {{ event.data.letter.subject }}
                                                                        </div>
                                                                    </template>
                                                                    <event-letter-mobile
                                                                        :event="eventLetterData"
                                                                    />
                                                                </el-collapse-item>
                                                            </el-collapse>
                                                        </div>
                                                    </template>
                                                    <template v-else-if="isEventRequestFromSite(event.event_type)">
                                                        <div>{{ event.data.message }}</div>
                                                        <div>{{ event.data.extraText }}</div>
                                                    </template>
                                                    <template v-else-if="showContactLink(event)">
                                                        <span
                                                            class="event-link pointer content-default"
                                                            v-if="messageIsset(event)"
                                                            @click="goContact(event.data.contactLink.id)"
                                                        >
                                                            {{ event.data.message }}
                                                            {{ isEventSms(event.event_type) ? ` ${event.data.contactLink.title} ${event.data.phoneNumber}`: '' }}
                                                        </span>
                                                    </template>
                                                    <template v-else-if="showEmployerLink(event)">
                                                        <span
                                                            class="event-link pointer content-default"
                                                            v-if="messageIsset(event) && !isEventCall(event.event_type)"
                                                            @click="goEmployer(event.data.employerLink.id)"
                                                        >
                                                            {{ event.data.message }}
                                                            {{ isEventSms(event.event_type) ? ` ${event.data.employerLink.title} ${event.data.phoneNumber}`: '' }}
                                                        </span>
                                                    </template>
                                                    <template v-else-if="showLeadLink(event)">
                                                        <span
                                                            class="event-link pointer content-default"
                                                            v-if="messageIsset(event)"
                                                            @click="goLead(event.data.leadLink.id)"
                                                        >
                                                            {{ event.data.message }}
                                                        </span>
                                                    </template>
                                                    <template v-else-if="isEventComment(event.event_type)">
                                                        <template v-if="event.data.amoId && !event.data.extratext ">
                                                            <div class="content-default">
                                                                {{ event.data.message }}
                                                            </div>
                                                        </template>
                                                        <template v-else>
                                                            <div class="content-default">
                                                                {{ event.data.extratext }}
                                                            </div>
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        <template v-if="!isEventCall(event.event_type)">
                                                            <div class="content-default">
                                                                {{ event.data.message }}
                                                            </div>
                                                        </template>
                                                    </template>
                                                </el-col>
                                            </el-row>
                                            <template v-if="isEventSms(event.event_type)">
                                                <el-row>
                                                    <el-col :span="24">
                                                        <em>
                                                            &nbsp;{{ event.data.extraText }}
                                                        </em>
                                                    </el-col>
                                                </el-row>
                                                <el-row>
                                                    <el-col :span="24">
                                                        Статус доставки: {{ event.data.statusText }}
                                                    </el-col>
                                                </el-row>
                                            </template>
                                            <template v-if="isEventComment(event.event_type)">
                                                <el-row>
                                                    <el-col :span="24">
                                                        <div v-html="prepareText(event.data.extraText)" class="content-default"></div>
                                                    </el-col>
                                                </el-row>
                                                <el-row v-if="event.data.attachments.length">
                                                    <el-col :span="21" class="event-attachments">
                                                        <el-tag
                                                            v-for="file in event.data.attachments"
                                                            :key="file.name"
                                                            :type="''"
                                                            size="mini"
                                                            :disable-transitions="true"
                                                        >
                                                            <div class="file-download-wrapper" @click="getAttachment(file)">
                                                                <span class="event-icon-download-orange download"></span>
                                                                <span class="filename">
                                                                    {{ file.name }}
                                                                </span>
                                                            </div>
                                                        </el-tag>
                                                    </el-col>
                                                </el-row>
                                            </template>
                                            <template v-if="isEventEmail(event.event_type) && event.data.attachments.length">
                                                <el-row>
                                                    <el-col :span="21" class="event-attachments">
                                                        <el-tag
                                                            v-for="file in event.data.attachments"
                                                            :key="file.name"
                                                            :type="''"
                                                            size="mini"
                                                            :disable-transitions="true"
                                                        >
                                                            <span class="event-icon-download-orange" @click="getAttachment(file)"></span>
                                                            <span>{{ file.name }}</span>
                                                        </el-tag>
                                                    </el-col>
                                                </el-row>
                                            </template>
                                        </el-col>
                                    </el-row>
                                </div>
                            </template>
                        </div>
                    </scrolly-viewport>
                    <scrolly-bar axis="y" />
                </scrolly>
                <div class="pagination-wrapper events-pagination" v-if="pagesInfo.total>15">
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="pagesInfo.total"
                        :page-size="pageModel.pageSize"
                        :current-page="pageModel.currentPage"
                        :pager-count="5"
                        @current-change="getCurrentPage"
                    />
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import '@/assets/styles/events.scss';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEye, faPaperclip } from '@fortawesome/free-solid-svg-icons';
import { Scrolly, ScrollyViewport, ScrollyBar } from 'vue-scrolly';
import { formatText, truncateText } from '@/common/utilities';
import FileSaver from 'file-saver';
import localReferences from '@/helpers/localReferences';
import EventLetterMobile from '@/components/events/EventLetterMobile';
import { eventBus } from '@/common/eventBus';

library.add(faEye, faPaperclip);

export default {
    name: 'EventsMobile',
    data() {
        return {
            isAttachmentVisible: [],
            isEventLetterVisible: true,
            eventLetterData: {
                data: {
                    letter: {}
                }
            },
            commentText: '',
            commentSending: false,
            editMode: true,
            uploadFileList: [],
            eventsShowPlayer: [],
            entityType: 'deal',
            pageModel: {
                currentPage: 1,
                pageSize: 15
            },
            filterSettings: [
                localReferences.event.eventTypes.eventCall,
                localReferences.event.eventTypes.eventIncomeCall,
                localReferences.event.eventTypes.eventOutcomeCall,
                localReferences.event.eventTypes.eventComment,
                localReferences.event.eventTypes.eventSms,
                localReferences.event.eventTypes.eventEmail,
                localReferences.event.eventTypes.eventIncomeEmail,
                localReferences.event.eventTypes.eventOutcomeEmail,
                localReferences.event.eventTypes.eventChange,
                localReferences.event.eventTypes.eventSelf,
                localReferences.event.eventTypes.eventSite
            ],
            loading: true
        };
    },
    components: {
        Scrolly,
        ScrollyViewport,
        ScrollyBar,
        EventLetterMobile
    },
    created() {
        if (this.entityId && this.entityId !== 0) {
            this.getEvents();
        }
        eventBus.$on('task-updated', (value) => {
            if (value) {
                this.getEvents();
            }
        });
    },
    computed: {
        eventsList() {
            return this.$store.state.events.events;
        },
        eventTypes() {
            return localReferences.event.eventTypes;
        },
        initiatorTypes() {
            return localReferences.event.initiatorTypes;
        },
        canAddComment() {
            return this.commentText.length || this.uploadFileList.length;
        },
        entityId() {
            return this.$store.state.deals.current.id;
        },
        pagesInfo() {
            return this.$store.state.events.pages;
        }
    },
    methods: {
        async getEvents() {
            try {
                const requestParams = {
                    data: {
                        size: this.pageModel.pageSize,
                        page: this.pageModel.currentPage,
                        filter: this.filterSettings
                    },
                    entity: {
                        type: this.entityType,
                        id: this.entityId
                    }
                };
                this.loading = true;
                await this.$store.dispatch('events/getPaginatedList', requestParams);
            } catch (e) {
                console.log(e);
            } finally {
                this.loading = false;
            }
        },
        getCurrentPage(page) {
            this.pageModel.currentPage = page;
            this.getEvents();
        },
        handleChange(file, fileList) {
            this.uploadFileList = fileList;
        },
        handleExceed() {
            this.$message({
                showClose: true,
                message: 'Внимание, лимит 10 файлов!',
                type: 'warning',
                duration: 5000,
                customClass: this.alertClass()
            });
        },
        handleClose(tag) {
            this.uploadFileList.splice(this.uploadFileList.indexOf(tag), 1);
        },
        eventIsset(event) {
            return (event && event.id && event.id > 0);
        },
        initiatorIsset(event) {
            return (event && event.data && event.data.initiator);
        },
        messageIsset(event) {
            return (event && event.data && event.data.message);
        },
        initiatorTitle(event) {
            if (
                [
                    this.eventTypes.eventCall,
                    this.eventTypes.eventIncomeCall,
                    this.eventTypes.eventOutcomeCall
                ].indexOf(event.event_type) > -1
            ) {
                return event.data.message;
            } else {
                if (event.data.initiator.info.title) {
                    return event.data.initiator.info.title;
                }
            }
            return null;
        },
        isEventEmail(type) {
            return [
                this.eventTypes.eventIncomeEmail,
                this.eventTypes.eventOutcomeEmail
            ].indexOf(type) > -1;
        },
        isEventComment(type) {
            return [
                this.eventTypes.eventComment
            ].indexOf(type) > -1;
        },
        isEventSms(type) {
            return this.eventTypes.eventSms === type;
        },
        isEventRequestFromSite(type) {
            return [
                this.eventTypes.eventSite
            ].indexOf(type) > -1;
        },
        isEventCall(type) {
            return [
                this.eventTypes.eventCall,
                this.eventTypes.eventIncomeCall,
                this.eventTypes.eventOutcomeCall
            ].indexOf(type) > -1;
        },
        getEventMainIconClass(type) {
            if (
                [
                    this.eventTypes.eventPartner,
                    this.eventTypes.eventSite,
                    this.eventTypes.eventSelf,
                    this.eventTypes.eventOffice,
                    this.eventTypes.eventChange
                ].indexOf(type) > -1
            ) {
                return 'icon-cogwheel';
            } else if (
                [
                    this.eventTypes.eventComment
                ].indexOf(type) > -1
            ) {
                return 'icon-comment';
            } else if (this.eventTypes.eventIncomeCall === type) {
                return 'icon-income-call';
            } else if (this.eventTypes.eventOutcomeCall === type) {
                return 'icon-outcome-call';
            } else if (
                [
                    this.eventTypes.eventSms
                ].indexOf(type) > -1
            ) {
                return 'icon-sms';
            } else if (
                [
                    this.eventTypes.eventRevvy
                ].indexOf(type) > -1
            ) {
                return 'icon-whatsApp';
            } else if (
                [
                    this.eventTypes.eventEmail,
                    this.eventTypes.eventIncomeEmail,
                    this.eventTypes.eventOutcomeEmail
                ].indexOf(type) > -1
            ) {
                return 'icon-email';
            } else if (
                [
                    this.eventTypes.eventCall
                ].indexOf(type) > -1
            ) {
                return 'icon-call-simple';
            }
            return type;
        },
        getEventWrapClass(type) {
            if (
                [
                    this.eventTypes.eventCall,
                    this.eventTypes.eventEmail,
                    this.eventTypes.eventIncomeEmail,
                    this.eventTypes.eventOutcomeEmail,
                    this.eventTypes.eventIncomeCall,
                    this.eventTypes.eventOutcomeCall,
                    this.eventTypes.eventComment,
                    this.eventTypes.eventSms
                ].indexOf(type) > -1
            ) {
                return 'card-event';
            }
            return 'card-event-empty';
        },
        showInitiatorLink(initiator) {
            return initiator.type === this.initiatorTypes.employer;
        },
        showContactLink(event) {
            return (event && event.data && Object.prototype.hasOwnProperty.call(event.data.contactLink && event.data.contactLink, 'id'));
        },
        showEmployerLink(event) {
            return (event && event.data && Object.prototype.hasOwnProperty.call(event.data.employerLink && event.data.employerLink, 'id'));
        },
        showLeadLink(event) {
            return (event && event.data && Object.prototype.hasOwnProperty.call(event.data.leadLink && event.data.leadLink, 'id'));
        },
        showHideAudio(event) {
            if (this.eventsShowPlayer.indexOf(event.id) > -1) {
                const startIndex = this.eventsShowPlayer.indexOf(event.id);
                this.eventsShowPlayer.splice(startIndex, 1);
            } else {
                this.eventsShowPlayer.push(event.id);
            }
        },
        isShowAudio(event) {
            return this.eventsShowPlayer.indexOf(event.id) > -1;
        },
        goEmployer(id) {
            this.$router.push({ name: 'employer-card', params: { id: '' + id } });
        },
        goLead(id) {
            this.$router.push({ name: 'lead-card', params: { id: '' + id } });
        },
        goContact(id) {
            this.$router.push({ name: 'contact-card', params: { id: '' + id } });
        },
        prepareText(text) {
            return formatText(truncateText(text, 470));
        },
        async getAttachment(file) {
            try {
                const response = await this.$store.dispatch('events/getAttachment', file.filename);
                FileSaver(new Blob([response.data], { type: file.type }), file.name);
            } catch (e) {
                console.log(e);
            }
        },
        showEventLetter(event) {
            this.isEventLetterVisible = !this.isEventLetterVisible;
            this.eventLetterData = event;
            this.$emit('changeVisibility', true);
        },
        changeVisibility() {
            if (this.isEventLetterVisible) {
                this.isEventLetterVisible = false;
                this.$emit('changeVisibility', false);
            }
        },
        addComment() {
            const formData = new FormData();
            formData.append('commentText', this.commentText);
            formData.set('files', JSON.stringify(this.uploadFileList));
            this.uploadFileList.forEach(file => {
                if (file.raw) {
                    formData.append('file' + file.uid, file.raw, file.raw.name);
                }
            });
            const params = {
                data: formData,
                entityType: this.entityType,
                entityId: this.entityId
            };
            if (!this.commentSending && this.canAddComment) {
                this.commentSending = true;
                this.$store.dispatch('events/addComment', params).then(() => {
                    this.commentSending = false;
                    this.commentText = '';
                    this.uploadFileList = [];
                }).catch(() => { this.commentSending = false; });
            }
        }
    },
    watch: {
        reload(value) {
            if (value) {
                this.getEvents();
            }
        }
    }
};
//TODO: сделать чтобы entity мог быть также и лидом
</script>
